import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=ce25e5d6&scoped=true&"
import script from "./Tasks.vue?vue&type=script&lang=js&"
export * from "./Tasks.vue?vue&type=script&lang=js&"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=ce25e5d6&prod&lang=scss&scoped=true&"
import style1 from "./Tasks.vue?vue&type=style&index=1&id=ce25e5d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce25e5d6",
  null
  
)

export default component.exports